import { useEffect, useState } from 'react';
import {
  getOriginalGoogleSearchText,
  getOriginalLandingPage,
  getOriginalReferer,
} from '~/scripts/attribution';
import {
  getGuestSearchHistory,
  type GuestHistoryItem,
} from '~/scripts/searchHistory';

/**
 * will be undefined until the page is loaded
 */
export default function useAttributionDetails() {
  const [history, setHistory] = useState<GuestHistoryItem[] | undefined>();
  const [referrer, setReferrer] = useState<string | undefined>();
  const [landing, setLanding] = useState<string | undefined>();
  const [searchtext, setSearchtext] = useState<string | undefined>();

  useEffect(() => {
    const history = getGuestSearchHistory();
    const referrer = getOriginalReferer();
    const landing = getOriginalLandingPage();
    const searchtext = getOriginalGoogleSearchText();
    setHistory(history);
    setReferrer(referrer);
    setLanding(landing);
    setSearchtext(searchtext);
  }, []);

  return { history, referrer, landing, searchtext };
}
